import { render, staticRenderFns } from "./PageMore.vue?vue&type=template&id=712f4efc&scoped=true&"
import script from "./PageMore.vue?vue&type=script&lang=ts&"
export * from "./PageMore.vue?vue&type=script&lang=ts&"
import style0 from "./PageMore.vue?vue&type=style&index=0&id=712f4efc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712f4efc",
  null
  
)

export default component.exports